export default function PageHeader({ eyebrow, title, description, actions, testId }) {
  return (
    <div className="border-b border-zinc-200 bg-white" data-testid={testId || "page-header"}>
      <div className="max-w-[1400px] mx-auto px-8 py-8 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div className="min-w-0">
          {eyebrow && (
            <div className="text-[10px] font-semibold uppercase tracking-[0.16em] text-zinc-500 mb-2">
              {eyebrow}
            </div>
          )}
          <h1 className="font-heading text-3xl md:text-4xl font-extrabold tracking-tight text-zinc-900">
            {title}
          </h1>
          {description && (
            <p className="mt-2 text-sm text-zinc-600 max-w-2xl leading-relaxed">{description}</p>
          )}
        </div>
        {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
      </div>
    </div>
  );
}
